var _path, _path2, _path3, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _path4, _path5, _rect17;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTitleInsurance(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 32,
    viewBox: "0 0 34 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.17262 7.4478H6.06917C4.52434 7.4478 3.31055 6.23401 3.31055 4.68918V3.03401C3.31055 1.48918 4.52434 0.275391 6.06917 0.275391H7.17262C8.71744 0.275391 9.93124 1.48918 9.93124 3.03401V4.68918C9.93124 6.23401 8.71744 7.4478 7.17262 7.4478ZM6.06917 1.37884C5.13124 1.37884 4.414 2.09608 4.414 3.03401V4.68918C4.414 5.62711 5.13124 6.34436 6.06917 6.34436H7.17262C8.11055 6.34436 8.82779 5.62711 8.82779 4.68918V3.03401C8.82779 2.09608 8.11055 1.37884 7.17262 1.37884H6.06917Z",
    fill: "#B2D235"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.1379 19.5862V15.7241H10.4828V31.1724C10.4828 31.5034 10.2621 31.7241 9.93103 31.7241H6.62069H3.31034C2.97931 31.7241 2.75862 31.5034 2.75862 31.1724V15.7241H1.10345V19.5862H0V11.8621C0 9.71034 1.71034 8 3.86207 8H9.37931C11.531 8 13.2414 9.71034 13.2414 11.8621V19.5862H12.1379ZM9.37931 30.6207V12.4138H10.4828V14.6207H12.1379V11.8621C12.1379 10.3172 10.9241 9.10345 9.37931 9.10345H7.17241V14.6207H6.06897V9.10345H3.86207C2.31724 9.10345 1.10345 10.3172 1.10345 11.8621V14.6207H2.75862V12.4138H3.86207V30.6207H6.06897V20.6897H4.96552V19.5862H8.27586V20.6897H7.17241V30.6207H9.37931Z",
    fill: "#B2D235"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5524 0.275391H11.5869C11.2558 0.275391 11.0352 0.49608 11.0352 0.827115V5.79263H12.1386V1.37884H32.0007V20.965L22.0696 28.7995L11.9179 20.7995L11.2558 21.6823L21.7386 29.9581C21.8489 30.0133 21.9593 30.0685 22.0696 30.0685C22.18 30.0685 22.2903 30.0133 22.4007 29.9581L32.8834 21.6823C33.049 21.5719 33.1041 21.4064 33.1041 21.2409V0.827115C33.1041 0.49608 32.8834 0.275391 32.5524 0.275391Z",
    fill: "#B2D235"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 13.793,
    y: 2.48242,
    width: 1.10345,
    height: 1.10345,
    fill: "#B2D235"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 2.48242,
    width: 1.10345,
    height: 1.10345,
    fill: "#B2D235"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 18.207,
    y: 2.48242,
    width: 1.10345,
    height: 1.10345,
    fill: "#B2D235"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 20.4141,
    y: 2.48242,
    width: 1.10345,
    height: 1.10345,
    fill: "#B2D235"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 22.6211,
    y: 2.48242,
    width: 1.10345,
    height: 1.10345,
    fill: "#B2D235"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 24.8281,
    y: 2.48242,
    width: 1.10345,
    height: 1.10345,
    fill: "#B2D235"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 27.0352,
    y: 2.48242,
    width: 1.10345,
    height: 1.10345,
    fill: "#B2D235"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 29.2422,
    y: 2.48242,
    width: 1.10345,
    height: 1.10345,
    fill: "#B2D235"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 13.793,
    y: 4.68945,
    width: 1.10345,
    height: 1.10345,
    fill: "#B2D235"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 4.68945,
    width: 1.10345,
    height: 1.10345,
    fill: "#B2D235"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 18.207,
    y: 4.68945,
    width: 1.10345,
    height: 1.10345,
    fill: "#B2D235"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 20.4141,
    y: 4.68945,
    width: 1.10345,
    height: 1.10345,
    fill: "#B2D235"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 22.6211,
    y: 4.68945,
    width: 1.10345,
    height: 1.10345,
    fill: "#B2D235"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 24.8281,
    y: 4.68945,
    width: 1.10345,
    height: 1.10345,
    fill: "#B2D235"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 27.0352,
    y: 4.68945,
    width: 1.10345,
    height: 1.10345,
    fill: "#B2D235"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 29.2422,
    y: 4.68945,
    width: 1.10345,
    height: 1.10345,
    fill: "#B2D235"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.1379 16.8268C28.1379 20.1923 25.4345 22.8957 22.069 22.8957C18.7034 22.8957 16 20.1923 16 16.8268C16 13.4613 18.7034 10.7578 22.069 10.7578C25.4345 10.7578 28.1379 13.4613 28.1379 16.8268ZM27.0345 16.8268C27.0345 14.0682 24.8276 11.8613 22.069 11.8613C19.3103 11.8613 17.1034 14.0682 17.1034 16.8268C17.1034 19.5854 19.3103 21.7923 22.069 21.7923C24.8276 21.7923 27.0345 19.5854 27.0345 16.8268Z",
    fill: "#B2D235"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9652 19.5861C21.1307 19.5861 21.2411 19.531 21.3514 19.4206L25.2135 15.5585L24.4411 14.7861L20.9652 18.262L19.6962 16.993L18.9238 17.7654L20.579 19.4206C20.6893 19.531 20.7997 19.5861 20.9652 19.5861Z",
    fill: "#B2D235"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 19.8613,
    y: 8,
    width: 4.41379,
    height: 1.10345,
    fill: "#B2D235"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTitleInsurance);
export default __webpack_public_path__ + "static/media/title-insurance.ded645f45471d7ee5f61c1ea7fb3afdd.svg";
export { ForwardRef as ReactComponent };